import React from "react";
import {ProductionStageFormCreate} from "../../components/production-stages/ProductionStageFormCreate";

export function CreateProductionStageForm() {


    return (
        <ProductionStageFormCreate/>
    )
}